import * as React from 'react'
import {connect} from 'react-redux'
import {ApplicationState, ConnectedReduxProps} from '@reducers/index'
import {deleteRequest, fetchRequest} from '@actions/person-role'
import PersonRolesTable from "@components/person-roles/Table";
import TableRenderer from "@hocs/TableRenderer";
import {PersonRole} from "@models/person-role";
import {FormattedMessage} from 'react-intl';
import {Button, Card} from "antd";
import PersonRoleForm from "@components/person-roles/Form";
import SearchPersolRolesComponent from "@components/person-roles/Search";
import {NavLink} from "react-router-dom";


interface PropsFromState {
  loading: boolean
  data: PersonRole[]
  errors?: string,
  count: number
}

interface PropsFromDispatch {
  fetchRequest: typeof fetchRequest
  deleteRequest: typeof deleteRequest
}

// Combine both state + dispatch props - as well as any props we want to pass - in a union type.
type AllProps = PropsFromState & PropsFromDispatch & ConnectedReduxProps


class PeopleRolesPage extends React.Component<AllProps> {
  
  deletePersonRole = (item: PersonRole): any => {
    this.props.deleteRequest({
      params: {
        id: item.id
      }
    })
  };
  
  render() {
    const {loading, data, search, currentPage} = this.props;
    return (
      <div>
        <div className={`toggle-button-wrapper`}>
          <NavLink to={`/people/roles/create`}>
            <Button type={'primary'}>
              <FormattedMessage
                id="app.create_new_role"
                defaultMessage={`Create Role`}/></Button>
          </NavLink>
        </div>
        <div className={'page-table-wrapper'}>
          <Card className={`page-table-header`} bordered={false}>
            <SearchPersolRolesComponent search={search}/>
          </Card>
          
          <PersonRolesTable data={data}
                            currentPage={currentPage}
                            rowKey={record => record.id}
                            deleteFn={this.deletePersonRole}
                            loading={loading}/>
        </div>
      
      </div>
    )
  }
}

const mapStateToProps = ({personRoles}: ApplicationState) => ({
  loading: personRoles.loading,
  errors: personRoles.errors,
  data: personRoles.data,
  count: personRoles.count
});

const mapDispatchToProps = {
  fetchRequest,
  deleteRequest
};

export default connect(mapStateToProps, mapDispatchToProps)(TableRenderer(PeopleRolesPage));


